export const lightDefaults = {
  hemisphere: {
    skyColor: [1, 1, 1] as [number, number, number],
    // Они используют очень нейтральный серый заполняющий свет
    groundColor: [0.5, 0.5, 0.5] as [number, number, number],
    // Высокая интенсивность, чтобы "убить" черноту
    intensity: 1.5,
  },
  directional: {
    // Основной свет (Key Light)
    intensity: 2.5,
    // Светит прямо "от зрителя" (позиция камеры) и чуть сверху
    // В Online3DViewer это вектор (1, 2, 4) или похожий
    position: [5, 10, 15] as [number, number, number],
  },
  // Они обязательно используют второй свет с противоположной стороны
  back: {
    intensity: 1.0,
    // Абсолютно противоположная позиция основному свету
    // Светит снизу-сзади, подсвечивая корни твоего цветка
    position: [-5, -10, -15] as [number, number, number],
  },
  ambient: {
    // Яркий нейтральный серый
    color: [0.4, 0.4, 0.4] as [number, number, number],
    intensity: 2.0,
  },
};
